// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3vI7g","choiceBoxes":"toolbarselects_choiceBoxes__2dDQq","simpleField":"toolbarselects_simpleField__E21St"};